var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var MailSvg = /* @__PURE__ */ __name(function MailSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M16.187 17.667l14.529-10.64v-0.178h-29.058v0.178l14.529 10.64z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M28.404 22.822l2.311 2.013-0.031-16.067-9.804 7.173 7.524 6.88z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M11.409 15.884l-9.724-7.116-0.027 16.031 9.751-8.916z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M16.187 19.307l-3.636-2.662-9.982 9.129h27.084l-9.916-9.067-3.551 2.6z"
  }));
}, "MailSvg");
var MailIcon = /* @__PURE__ */ __name(function MailIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: MailSvg
  }, props));
}, "MailIcon");
export {
  MailIcon
};
